import { render, staticRenderFns } from "./UserProfileIcon.vue?vue&type=template&id=0d15da38"
import script from "./UserProfileIcon.vue?vue&type=script&lang=js"
export * from "./UserProfileIcon.vue?vue&type=script&lang=js"
import style0 from "./UserProfileIcon.vue?vue&type=style&index=0&id=0d15da38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports